import { SaleDetailModel } from 'api-hooks/sale/model';
import * as React from 'react';

import FlightRescheduleForm from './form';

interface Props {
  flightSale: SaleDetailModel;
}

export default function FlightReschedule(props: Props) {
  const { flightSale } = props;
  return <FlightRescheduleForm {...props} flightSale={flightSale} />;
}
